<template>
  <div :style="labelText.length == 0 ? 'margin:-18px 10px;width:' + width : 'width:' + width">
    <v-select
      :label="labelText"
      v-model="dataSource"
      :item-value="dataValueField"
      :item-text="dataTextField"
      :items="value"
      :disabled="isDisabled"
      :max-height="maxHeight"
      v-on:change="onChangeItem"
      dense
      multiple
      required
    >
      <v-list-tile v-show="showSelectAll" slot="prepend-item" ripple @click="toggle">
        <v-list-tile-action>
          <v-icon style="font-size:39px" :color="selectAllItems ? 'indigo darken-4' : ''">{{
            icon
          }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{ selectAllLabel }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-show="showSearch" slot="prepend-item" ripple>
        <v-combobox
          :item-value="dataValueField"
          :item-text="dataTextField"
          :items="value"
          :search-input.sync="search"
          v-on:change="onChangeSearch"
          label="Search"
          append-icon="search"
          clear-icon="clear"
          clearable
        />
      </v-list-tile>
      <v-divider v-show="showSelectAll || showSearch" slot="prepend-item" class="mt-2"></v-divider>
      <template v-slot:selection="{item, index}">
        <v-chip v-if="index <= numberOfItems - 1">
          <span>{{ item[dataTextField] }}</span>
        </v-chip>
        <v-chip label v-if="index === numberOfItems">
          <span style="text-transform:capitalize">
            (+{{ dataSource.length - numberOfItems }} {{ itemText
            }}{{ dataSource.length - numberOfItems == 1 ? '' : 's' }})
          </span>
        </v-chip>
      </template>
      <v-divider slot="append-item" class="mb-2"></v-divider>
      <v-list-tile slot="append-item" disabled>
        <v-list-tile-avatar color="grey lighten-3">
          <v-icon>{{ itemIcon }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content style="text-transform:capitalize">
          <v-list-tile-title v-if="selectAllItems">All {{ itemText }}s selected!</v-list-tile-title>
          <v-list-tile-title v-else-if="selectItems"
            >{{ dataSource.length }} {{ itemText
            }}{{ dataSource.length == 1 ? '' : 's' }} selected.</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'VisionapSwitchList',
  props: {
    dataSource: {type: Array, required: true},
    value: {type: Array, required: true},
    dataValueField: {type: String, required: true},
    dataTextField: {type: String, required: true},
    labelText: {type: String, default: ''},
    itemText: {type: String, default: 'Item'},
    itemIcon: {type: String, default: 'format_list_numbered'},
    numberOfItems: {type: Number, default: 2},
    showSelectAll: {type: Boolean, default: true},
    selectAllLabel: {type: String, default: 'Select all'},
    showSearch: {type: Boolean, default: true},
    width: {type: String, default: '100%'},
    maxHeight: {type: String, default: '632px'},
    isDisabled: {type: Boolean, default: false},
  },
  computed: {
    selectAllItems() {
      return this.dataSource.length === this.value.length
    },
    selectItems() {
      return this.dataSource.length > 0 && !this.selectAllItems
    },
    icon() {
      if (this.selectAllItems) return 'toggle_on'
      if (this.selectItems) return 'toggle_off'
      return 'remove'
    },
  },
  data() {
    return {
      search: '',
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllItems) {
          this.$emit('input', [])
        } else {
          this.$emit('input', this.value.map(e => e[this.dataValueField]))
        }
      })
    },
    onChangeSearch(item) {
      const validSearch = item != null && !this.dataSource.includes(item[this.dataValueField])
      if (!validSearch) return

      let selectedItems = this.dataSource
      selectedItems.push(item[this.dataValueField])
      this.$emit('input', selectedItems)
    },
    onChangeItem(items) {
      this.$emit('input', items)
    },
  },
}
</script>
